import { CanActivateFn } from '@angular/router';
import { inject } from "@angular/core";
import { AuthService } from "@services/auth/auth.service";
import { map } from "rxjs/operators";
import { BASE_AUTH_URL } from "@app/core/core.module";

export const autoLoginGuard: CanActivateFn = (route, state) => {
  let authService = inject(AuthService)
  let authBaseUrl = inject(BASE_AUTH_URL);

  return authService.isAuthenticated$.pipe(
    map(isAuthenticated => {
      if (!isAuthenticated) {
        // Redirect to the login page or perform any other action
        location.href = authBaseUrl + '/login?redirect_uri=' + encodeURIComponent(window.location.origin + state.url);
        return false;
      }
      return true;
    })
  );
};
